/**
 * Chrome institucional público (Home / Legal / Help).
 *
 * Destino futuro: packages/brand. Sem Firestore, billing, projects,
 * conteúdo legal ou conteúdo da Ajuda.
 *
 * Social: URLs vazias → ícones disabled (mesmo comportamento atual da Home,
 * alinhado a ACCESS_EARLY_CONFIG). PublicFooter lê a LP só como fonte das
 * URLs; não altera a campanha.
 */

export const PUBLIC_HEADER_CONTEXTS = Object.freeze({
  home: "home",
  legal: "legal",
  help: "help",
});

export const PUBLIC_FOOTER_CONTEXTS = PUBLIC_HEADER_CONTEXTS;

/** Âncoras da Home — não usar em Legal/Help. */
export const HOME_NAV_LINKS = Object.freeze([
  { label: "Recursos", href: "#recursos" },
  { label: "Demo", href: "#demo" },
  { label: "Como funciona", href: "#como-funciona" },
  { label: "Preços", href: "#precos" },
  { label: "FAQ", href: "#faq" },
]);

export const PUBLIC_LEGAL_LINKS = Object.freeze([
  { label: "Termos de Uso", to: "/termos", testId: "public-footer-terms" },
  { label: "Política de Privacidade", to: "/privacidade", testId: "public-footer-privacy" },
  { label: "Ajuda", to: "/ajuda", testId: "public-footer-help" },
]);

const HELP_CONTEXT_LABEL = "Central de Ajuda";

/**
 * @param {string} [context]
 * @param {{ contextLabel?: string | null }} [options]
 * @returns {{
 *   context: "home" | "legal" | "help",
 *   navLinks: readonly { label: string, href: string }[],
 *   contextLabel: string | null,
 *   actions: "auth" | "help" | "docs",
 *   brandHref: string,
 * }}
 */
export function getPublicHeaderConfig(context, options = {}) {
  if (context === PUBLIC_HEADER_CONTEXTS.legal) {
    return {
      context: PUBLIC_HEADER_CONTEXTS.legal,
      navLinks: [],
      contextLabel: options.contextLabel ?? null,
      actions: "docs",
      brandHref: "/",
    };
  }

  if (context === PUBLIC_HEADER_CONTEXTS.help) {
    return {
      context: PUBLIC_HEADER_CONTEXTS.help,
      navLinks: [],
      contextLabel: options.contextLabel ?? HELP_CONTEXT_LABEL,
      actions: "help",
      brandHref: "/ajuda",
    };
  }

  return {
    context: PUBLIC_HEADER_CONTEXTS.home,
    navLinks: HOME_NAV_LINKS,
    contextLabel: null,
    actions: "auth",
    brandHref: "/",
  };
}

/**
 * @param {string} [context]
 * @returns {{ context: "home" | "legal" | "help", showHomeNav: boolean }}
 */
export function getPublicFooterConfig(context) {
  if (
    context === PUBLIC_FOOTER_CONTEXTS.legal ||
    context === PUBLIC_FOOTER_CONTEXTS.help
  ) {
    return { context, showHomeNav: false };
  }

  return {
    context: PUBLIC_FOOTER_CONTEXTS.home,
    showHomeNav: true,
  };
}
